<div class="blank-layout-container justify-content-center">
  <div class="row">
    <div class="col-12 text-center">
      <img src="/assets/images/logos/f4rm-logo-text.png" alt="error-bg" class="logolight" width="350" height="109"
        style="margin: 0 auto;" />
      <img src="/assets/images/logos/f4rm-logo-text-inverted.png" alt="error-bg" class="logodark" width="350"
        height="109" style="margin: 0 auto;" />
      <h2 class="auth-title f-w-600 m-t-48">{{ '404.howDidYouLandHere' | translate }}</h2>
      <h6 class="f-s-20 f-w-600 m-y-30">{{ '404.subcontent' | translate }}</h6>
      <app-mat3-button [text]="'404.back' | translate" variant="primary" [routerLink]="['/']"></app-mat3-button>
    </div>
  </div>
</div>